/** Presentation only. Never grants admission or changes world/session authority. */
export const isSsxEntryPath = path => /^\/worlds\/ssx\/?$/.test(path ?? '');
export function createSsxEntryPresentation({direct = false, document, history, location}) {
  let active = direct, pending = direct;
  const original = new Map();
  function text(selector, value, attribute, fallback) {
    const node = document.querySelector(selector);
    if (!node) return;
    const key = selector + ':' + (attribute ?? 'text');
    if (!original.has(key)) original.set(key, fallback ?? (attribute ? node.getAttribute(attribute) : node.textContent));
    const next = active ? value : original.get(key);
    if (attribute) { if (next === null) node.removeAttribute(attribute); else node.setAttribute(attribute, next); }
    else node.textContent = next;
  }
  function render() {
    document.documentElement.dataset.experienceMode = active ? 'ssx' : 'valoria';
    document.documentElement.dataset.ssxEntryPending = String(pending);
    document.title = active ? 'SSX 3 · Snow Jam' : 'Valoria';
    text('.brand', 'SSX 3', undefined, 'Valoria');
    text('.brand', 'SSX 3, return to game', 'aria-label', 'Valoria, return to world');
    text('#world', 'SSX 3 Snow Jam. Use the riding controls to snowboard; Exit SSX leaves this mode.', 'aria-label');
    text('#loading h2', 'SSX 3', undefined, 'Valoria');
    text('#panel', 'SSX navigation', 'aria-label');
    text('#signin-button', 'Sign in', 'title');
  }
  return Object.freeze({
    active: () => active,
    render,
    enter() { active = true; pending = false; render(); },
    // Called only after the existing activity's acknowledged return callback.
    returned() {
      active = false; pending = false; render();
      // Replace rather than push: back/reload must not silently re-admit a rider
      // who has already left. Other URLs and query/hash state remain untouched.
      if (isSsxEntryPath(location.pathname)) history.replaceState(history.state, '', '/' + (location.search ?? '') + (location.hash ?? ''));
    },
  });
}
